<template>
  <GlobalWindow
    :title="title"
    width="900px"
    :withFooter="false"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
      <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="浏览类型">
              <el-select v-model="form.type" placeholder="请选择">
                  <el-option label="浏览房源" value="1"></el-option>
                  <el-option label="咨询房源" value="2"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="时间范围">
              <el-date-picker
                  v-model="form.time"
                  type="datetimerange"
                  @change="changeTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
      </el-form>
      <el-table
          :data="list"
          border
          v-loading="loading"
          style="width: 100%">
          <el-table-column prop="title" label="小区名称" min-width="200px"></el-table-column>
          <el-table-column label="栋数">
              <template slot-scope="{row}">
                  <span>{{row.buildingNum}}栋</span>
              </template>
          </el-table-column>
          <el-table-column prop="roomNum" label="门牌号"></el-table-column>
          <el-table-column label="户型" min-width="100px">
              <template slot-scope="{row}">
                  <span>{{row.bedroomNum}}房{{row.saloonNum || ''}}厅{{row.toiletNum || ''}}卫</span>
              </template>
          </el-table-column>
          <el-table-column label="面积">
              <template slot-scope="{row}">
                  <span>{{row.area}}㎡</span>
              </template>
          </el-table-column>
          <el-table-column label="房源状态" min-width="100px">
              <template slot-scope="{row}">
                  <span style="color: red;" v-if="row.status === 0">下架</span>
                  <span style="color: green;" v-if="row.status === 1">上架</span>
              </template>
          </el-table-column>
          <el-table-column prop="price" label="租金（元）"></el-table-column>
          <el-table-column prop="sellPrice" label="售价（万元）"></el-table-column>
          <el-table-column label="审核状态" min-width="100px">
              <template slot-scope="{row}">
                  <span v-if="row.reviewStatus === 0">审核中</span>
                  <span style="color: green;" v-if="row.reviewStatus === 1">已通过</span>
                  <span style="color: red;" v-if="row.reviewStatus === 2">未通过</span>
              </template>
          </el-table-column>
          <el-table-column prop="reviewUserName" label="审核人" min-width="100px"></el-table-column>
          <el-table-column prop="createTime" label="发布时间" min-width="100px"></el-table-column>
          <el-table-column prop="createUserName" label="发布人" min-width="100px"></el-table-column>
          <el-table-column prop="publisherPhone" label="发布人手机号" min-width="100px"></el-table-column>
          <el-table-column prop="phone" label="房东手机号" min-width="100px"></el-table-column>
          <el-table-column label="房源类别" min-width="90px">
            <template slot-scope="{row}">
                <span v-if="row.isMiddlemanLandlord === 0">房东</span>
                <span v-else-if="row.isMiddlemanLandlord === 1">二房东</span>
              </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
      </el-table>
      <div style="width: 100%; text-align: right; margin-top: 20px;">
          <el-pagination
              @current-change="changePage"
              layout="total, prev, pager, next"
              :total="total">
          </el-pagination>
      </div>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { getHouseViewNum2 } from '@/api/rentHouse/rhHouse'
export default {
  name: 'userData',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
    // 表单数据
      form: {
        userId: null,
        phone: '',
        type: '1',
        time: [],
        startTime: '',
        endTime: ''
      },
      list: [],
      page: 1,
      capacity: 10,
      total: 0,
      loading: false,
      base: process.env.VUE_APP_API_IMG
    }
  },
  methods: {
    open (title, target) {
      this.title = title
      this.form.userId = target
      this.form.type = '1'
      this.list = []
      this.page = 1
      this.visible = true
      this.getList()
    },
    changeTime (e) {
      if (!e) {
        this.form.startTime = ''
        this.form.endTime = ''
      } else {
        this.form.startTime = e[0]
        this.form.endTime = e[0]
      }
    },
    changePage (e) {
      this.page = e
      this.getList()
    },
    getList (page) {
      if (page) {
        this.page = page
      }
      this.loading = true
      getHouseViewNum2({
        capacity: this.capacity,
        page: this.page,
        model: this.form
      }).then(res => {
        this.list = res.records
        this.total = res.total
        this.loading = false
      })
    }
  }
}
</script>
